import {Suspense, useRef, useState} from "react";
import PropertyLibrary from "components/PropertyLibrary";
import styles from "./index.module.scss";
import SelectDropDown from "../../../Common/Dropdown/SelectDropDown";
import textureDefault from "../../../../assets/image/Layout/PropertyPanel/ic_plus.svg";
import Spinner from "components/Layout/components/ObjectPanel/fallbacks/Spinner";
const TextureLibraryInput = ({name, propertyName, inputOnChange, thumbnail}) => {
  const inpRef = useRef();
  const dropRef = useRef();
  const [isLibraryOpened, setIsLibraryOpened] = useState(false);
  const [isDropDownOpened, setIsDropDownOpened] = useState(false);

  const openFileInput = () => {
    inpRef.current && inpRef.current.click();
  };

  const handleLibrary = () => {
    setIsLibraryOpened(!isLibraryOpened);
  };

  const handleDropdown = () => {
    setIsDropDownOpened(prev => !prev);
  };

  const resetBackground = () => {
    inputOnChange(name, null);
  };
  return (
    <div className={styles.container}>
      <p className={styles.title}>{name}</p>
      <div>
        <img
          ref={dropRef}
          className={styles.texture_box}
          src={thumbnail ? thumbnail : textureDefault}
          alt="material"
          onClick={!thumbnail && name === "Equirect" ? openFileInput : handleDropdown}
        />
        <input
          ref={inpRef}
          type="file"
          className={styles.input_file}
          onChange={e => {
            const imgUrl = window.URL.createObjectURL(e.target.files[0]);
            inputOnChange(name, imgUrl);
          }}
        />
        {isLibraryOpened && (
          <Suspense fallback={<Spinner />}>
            <PropertyLibrary name={name} propertyName={propertyName} onClickItem={inputOnChange} onClickClose={handleLibrary} />
          </Suspense>
        )}
        {isDropDownOpened && (
          <SelectDropDown style={{width: "186px", top: "2px"}} closeDropDown={() => setIsDropDownOpened(false)}>
            {(name === "Map" || name === "Normal Map") && (
              <div onClick={handleLibrary}>
                <p>Go to Asset Library</p>
              </div>
            )}
            <div onClick={openFileInput}>Import from Desktop</div>
            {thumbnail && (
              <div className={styles.drop_del} onClick={resetBackground}>
                Delete
              </div>
            )}
          </SelectDropDown>
        )}
      </div>
    </div>
  );
};

export default TextureLibraryInput;
